import api from '@/js/services/api';
export default {
    exportStands(dataToSend) {
        return api().post('/master-admin/stand-by-list/export', dataToSend, {responseType: 'blob'})
    },

    getList(filters) {
        const searchParams = new URLSearchParams();

        for (const [key, value] of Object.entries(filters)) {
            searchParams.append(key, value)
        }

        return api().get('/master-admin/stand-by-list/get?' + searchParams.toString())
    },

    updateComment(id, comment) {
        return api().put('/master-admin/stand-by-list/' + id + '/comment', {comment})
    },


}
